import { render, staticRenderFns } from "./DonorUrine.vue?vue&type=template&id=edad510c"
import script from "./DonorUrine.vue?vue&type=script&lang=js"
export * from "./DonorUrine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports